// @catalog F.006
// @catalog F.030
// PageHead — title + subtitle dinámico + slot derecho para period chips +
// compare selector + acciones (filter / export). Layout consistente
// entre /ventas y /margenes.
import type { ReactNode } from "react";
import { Box, Stack, Typography } from "@mui/material";

interface PageHeadProps {
  title: string;
  subtitle?: ReactNode;
  // Slot derecho — habitualmente PeriodSelector + CompareSelector + acciones.
  actions?: ReactNode;
}

export function PageHead(props: PageHeadProps): JSX.Element {
  const { title, subtitle, actions } = props;

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: "12px",
        marginBottom: "20px",
        flexWrap: "wrap",
      }}
    >
      <Box sx={{ minWidth: 280 }}>
        <Typography
          component="h1"
          sx={{
            fontSize: "24px",
            fontWeight: 600,
            letterSpacing: "-0.02em",
            color: "var(--ink-1)",
            margin: 0,
          }}
        >
          {title}
        </Typography>
        {subtitle && (
          <Box
            sx={{
              color: "var(--ink-3)",
              fontSize: "13.5px",
              marginTop: "4px",
              fontVariantNumeric: "tabular-nums",
            }}
          >
            {subtitle}
          </Box>
        )}
      </Box>
      <Box sx={{ flex: 1 }} />
      {actions && (
        <Stack
          direction="row"
          spacing={1}
          sx={{
            flexWrap: "wrap",
            justifyContent: "flex-end",
            rowGap: "8px",
          }}
        >
          {actions}
        </Stack>
      )}
    </Box>
  );
}
